// src/components/Sidebar.js
import React, { useContext, useMemo } from "react";
import { MultipleMenu, Logout } from "../components/sidebar";
import { DrawerContext } from "../context/Drawer";
import Section from "../components/elements/Section";
import data from "../data/master/sidebar.json";

export default function Sidebar() {
  const { drawer } = useContext(DrawerContext);

  const filteredNavs = useMemo(() => {
    const rawNavs = data.navs || [];
    const userStr = localStorage.getItem("user");
    const adminStr = localStorage.getItem("admin");
    const isAdmin = !userStr && Boolean(adminStr);

    // Check if admin is Master Admin
    let isMasterAdmin = false;
    if (isAdmin && adminStr) {
      try {
        const admin = JSON.parse(adminStr);
        isMasterAdmin = admin.isMasterAdmin === true;
      } catch {
        // ignore parse errors
      }
    }

    // Admin sees everything (filter masterAdminOnly items)
    if (isAdmin) {
      return rawNavs.map((section) => {
        const filteredMenu = section.menu.filter((item) => {
          // If item is masterAdminOnly, only show to Master Admin
          if (item.masterAdminOnly) {
            return isMasterAdmin;
          }
          return true;
        });
        return { ...section, menu: filteredMenu };
      });
    }

    // No user or admin → show nothing
    if (!userStr) {
      return [];
    }

    // User view: filter by their access_level
    let user;
    try {
      user = JSON.parse(userStr);
    } catch {
      return [];
    }
    const accessLevels = user.access_level || [];

    // map menu text → module key
    const moduleTextMap = {
      Items: "ITEMS_MODULE",
      Storehouses: "ITEMS_MODULE",
      Tabs: "ITEMS_MODULE",
      Quadrants: "ITEMS_MODULE",
      Filters: "ITEMS_MODULE",
      Jobs: "JOBS_MODULE",
      Orders: "ORDERS_MODULE",
    };

    moduleTextMap["Sub Category 1"] = "ITEMS_MODULE";
    moduleTextMap["Sub Category 2"] = "ITEMS_MODULE";

    return (
      rawNavs
        .map((section) => {
          // filter this section's menu
          const menu = section.menu.filter((item) => {
            const moduleKey = moduleTextMap[item.text];
            // if it's one of the module tabs, only show if user has it
            if (moduleKey) {
              return accessLevels.includes(moduleKey);
            }
            // otherwise (dashboard, users, categories, etc.) show always
            //   return true;
          });
          return { ...section, menu };
        })
        // drop any empty sections
        .filter((section) => section.menu.length > 0)
    );
  }, [drawer]);

  console.log(filteredNavs);
  return (
    <Section
      as="aside"
      className={`mc-sidebar thin-scrolling ${drawer ? "active" : ""}`}
    >
      <MultipleMenu data={filteredNavs} />
      <Logout data={data.button} />
    </Section>
  );
}
